
import SliderComponent from '@components/Slider';

import { WagtailImage } from '@/types';
import Image from '@components/Image';

type Props = { images: WagtailImage[] };

function Slider(props: Props) {
  const { images } = props;

  if (!images) {
    return null;
  }

  return (
    <div className='streamfield slider'>
      <SliderComponent>
        {images.map(image => (
          <Image image={image} className='slider__image' key={image.id} />
        ))}
      </SliderComponent>
    </div>
  );
}
export default Slider;


